export { default as MenuIcon } from '@material-ui/icons/Menu';
export { default as PersonIcon } from '@material-ui/icons/PersonOutline';
export { default as LogoutIcon } from '@material-ui/icons/LockOpen';
export { default as HomeIcon } from '@material-ui/icons/HomeOutlined';
export { default as BackIcon } from '@material-ui/icons/ArrowBack';
export { default as ExpandIcon } from '@material-ui/icons/ExpandMore';
export { default as CollapseIcon } from '@material-ui/icons/ExpandLess';
export { default as CheckedIcon } from '@material-ui/icons/CheckBox';
export { default as SearchIcon } from '@material-ui/icons/Search';
export { default as ClearIcon } from '@material-ui/icons/Clear';
export { default as OpenInNewWindowIcon } from '@material-ui/icons/OpenInNew';
export { default as PrevIcon } from '@material-ui/icons/KeyboardArrowLeft';
export { default as NextIcon } from '@material-ui/icons/KeyboardArrowRight';
export { default as CompletedIcon } from '@material-ui/icons/Done';
export { default as CloseIcon } from '@material-ui/icons/Close';
export { default as EditIcon } from '@material-ui/icons/Edit';
export { default as CancelIcon } from '@material-ui/icons/Close';
export { default as SaveIcon } from '@material-ui/icons/Save';
export { default as GridIcon } from '@material-ui/icons/Dashboard';
export { default as SkillIcon } from '@material-ui/icons/StarBorderOutlined';
export { default as ForwardIcon } from '@material-ui/icons/ArrowForward';
export { default as PhoneIcon } from '@material-ui/icons/PhoneAndroid';
export { default as EmailIcon } from '@material-ui/icons/EmailOutlined';
export { default as CorrectIcon } from '@material-ui/icons/Star';
export { default as CorrectMarkerIcon } from '@material-ui/icons/StarBorder';
export { default as IncorrectIcon } from '@material-ui/icons/Clear';
export { default as InfoIcon } from '@material-ui/icons/InfoOutlined';
export { default as AddIcon } from '@material-ui/icons/AddCircleOutline';
export { default as RemoveIcon } from '@material-ui/icons/RemoveCircleOutline';
export { default as DownloadIcon } from '@material-ui/icons/CloudDownloadOutlined';
export { default as NoteIcon } from '@material-ui/icons/AssignmentOutlined';
export { default as PlusIcon } from '@material-ui/icons/Add';
export { default as OrgIcon } from '@material-ui/icons/AccountBalance';
export { default as RoleIcon } from '@material-ui/icons/SupervisedUserCircle';
export { default as CommentIcon } from '@material-ui/icons/Comment';
export { default as PrintIcon } from '@material-ui/icons/Print';
export { default as AddAccountIcon } from '@material-ui/icons/PersonAdd';
export { default as UserAccessIcon } from '@material-ui/icons/AccountBox';
export { default as TimeIcon } from '@material-ui/icons/Schedule';
export { default as CalendarIcon } from '@material-ui/icons/DateRange';
